export const WHATSAPP_BUSINESS_INTEGRATION_URL = '/home/integrations/whatsapp-business';

export function whatsappBusinessIntegrationUrl(search?: string | URLSearchParams): string {
  const params = new URLSearchParams(search ?? '');
  params.delete('section');
  const qs = params.toString();
  return qs ? `${WHATSAPP_BUSINESS_INTEGRATION_URL}?${qs}` : WHATSAPP_BUSINESS_INTEGRATION_URL;
}
